// components/OrderRefund/component.js
import React, { useState } from "react";
import "./OrderRefund.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import {
  Button,
  Box,
  Typography,
  Divider,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Radio,
  RadioGroup,
  FormLabel,
  FormControlLabel
} from "@mui/material";
import moment from "moment-timezone";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import refund_upon from "../../../assests/refund_upon.svg";
import refundschdulesuccess from "../../../assests/refundschdulesuccess.svg";
import notrequired from "../../../assests/notrequired.svg";
import refund_success from "../../../assests/refund_success.svg";
import failedrefundicon from "../../../assests/failedrefundicon.svg";
import checkIconGreen from "../../../assests/checkIconGreen.svg";
import refundNotreq from "../../../assests/refundNotreq.svg";
import emptyCircleIcon from "../../../assests/emptyCircleIcon.svg";
import indicator from "../../../assests/indictor.svg";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import HistoryIcon from '@mui/icons-material/History';
import autorefundIcon from "../../../assests/autorefundIcon.svg";

const OrderRefundComponent = ({
  refundOrderId = "24568794",
  refundOrderAmount,
  handleRefundOrderAmount,
  source,
  orderRefundApi,
  handleKeyPress,
  pgName,
  handleRefundReason,
  refundReason,
  refundSource,
  handleRefundSourceChange,
  handleRevoke,
  toggleHistory,
  historyData,
  setShowHistory,
  showHistory,
  loading,
  orderStatus
}) => {
  const navigate = useNavigate();
  const refundDetails = orderStatus || [];
  const [openRevokeDialog, setOpenRevokeDialog] = useState(false);

  const handleBackClick = () => navigate(-1);
  const handleOpenRevokeDialog = () => setOpenRevokeDialog(true);
  const handleCloseRevokeDialog = () => setOpenRevokeDialog(false);
  const handleConfirmRevoke = () => {
    handleRevoke();
    handleCloseRevokeDialog();
  };

  // ✅ Function to convert UTC to IST (Indian Standard Time)
  const convertUTCToIST = (utcDate) => {
    if (!utcDate) return "N/A";
    return moment.utc(utcDate).tz("Asia/Kolkata").format("DD MMM YYYY, h:mm A");
  };

  // ✅ Function to format date for display
  const formatDate = (date) => {
    if (!date) return "N/A";
    return moment(date).format("DD MMM YYYY, h:mm A");
  };

  // ✅ Format history data with IST time
  const formattedHistoryData = historyData?.map(item => ({
    ...item,
    date: item.date ? convertUTCToIST(item.date) : "N/A",
    refundInitiatedTime: item.refundInitiatedTime ? convertUTCToIST(item.refundInitiatedTime) : "N/A",
    refundCreditTime: item.refundCreditTime ? convertUTCToIST(item.refundCreditTime) : "N/A",
  })) || [];

  console.log("orderStatus", orderStatus?.refundDetailInfoList);
  console.log("history data component", historyData);

  const statusConfig = {
    REFUND_UPON_REQUEST: {
      icon: refund_upon,
      color: "#F28618",
      message: "If the customer did not receive any product, verify and initiate a manual refund.",
      exeptedSatlementMsg: "Expected Settlement Time: once Refund confirm (refund schedule time + 60 minutes)",
      successMSG: "Refund will be processed to your payment source"
    },
    REFUND_SCHEDULED: {
      icon: refundschdulesuccess,
      color: "#14AE78",
      message: "Your refund has been successfully scheduled and will be initiated in 40mins.",
      exeptedSatlementMsg: "Expected Settlement Time: once Refund confirm (refund schedule time + 60 minutes)",
      successMSG: "Refund will be processed to your payment source."
    },
    REFUND_SUCCESSFUL: {
      icon: refund_success,
      color: "#14AE78",
      message: "Refund reference number is 12345678",
      successMSG: "Refund successfully credited to your payment source."
    },
    REFUND_INITIATION_FAILED: {
      icon: notrequired,
      color: "#DC3545",
      message: "kindly refund manually or ask admin to refund by a payment gateway dashboards.",
      successMSG: "Refund will be processed to your payment source.",
      exceptedSTimer: "Expected Settlement Time: after initiation  ",
    },
    REFUND_NOT_REQUIRED: {
      icon: refundNotreq,
      color: "#DC3545",
      message: "If customer has any concern, kindly ask for product image and then initiate manual refund.",
      successMSG: "Refund will be processed to your payment source.",
      exceptedSTimer: "Expected Settlement Time: after initiation  ",
    },
    REFUND_INITIATED: {
      icon: checkIconGreen,
      color: "#DC3545",
      message: "If customer has any concern, kindly ask for product image and then initiate manual refund.",
      successMSG: "Refund will be processed to your payment source.",
      exceptedSTimer: "Expected settlement time(refund initiation time + 60 min or value returned by API) ",
    },
    REFUND_FAILED: {
      icon: failedrefundicon,
      color: "#DC3545",
      message: "refund could not be processed due to a technical issue.",
      successMSG: "Refund will be processed to your payment source.",
      exceptedSTimer: "Expected settlement time(refund initiation time + 60 min or value returned by API) ",
    },
  };

  return (
    <div className="order-refund-container">
      <Sidebar />

      <div className="order-refund-content">
        <div className="order-refund-header">
          <button onClick={handleBackClick} className="back-button">
            <img src={leftArrow} alt="Back" />
          </button>
          <h2>Bank Refund</h2>
        </div>

        <div className="refund-split-container">
          <div className="refund-form-section">
            <section className="refund-amount-section">
              <TextField
                fullWidth
                label="Enter Refund Amount"
                type="number"
                value={refundOrderAmount}
                onChange={handleRefundOrderAmount}
                onKeyPress={handleKeyPress}
                autoComplete="off"
                className="refund-amount-input"
                InputLabelProps={{
                  style: { color: '#666', fontSize: '14px' }
                }}
              />

              {refundDetails?.refundDetailInfoList?.length > 0 && (
                <Typography variant="body2" className="max-refund">
                  Max Refund Can Be Done ₹
                  {refundDetails.refundDetailInfoList[0].maxRefundAmount}
                </Typography>
              )}

              <TextField
                fullWidth
                label="Reason for Refund"
                type="text"
                value={refundReason}
                onChange={handleRefundReason}
                onKeyPress={handleKeyPress}
                autoComplete="off"
                className="refund-amount-input"
                InputLabelProps={{
                  style: { color: '#666', fontSize: '14px' }
                }}
              />

              {(pgName === "RAZORPAY") && (
                <FormControl className="refund-mode-selector">
                  <FormLabel style={{ color: '#333', fontSize: '14px', marginBottom: '8px' }}>
                    Select Refund Mode:
                  </FormLabel>
                  <RadioGroup
                    value={refundSource}
                    onChange={handleRefundSourceChange}
                  >
                    <FormControlLabel
                      value="source"
                      control={<Radio size="small" />}
                      label="Back to Source"
                      style={{ fontSize: '14px' }}
                    />
                    <FormControlLabel
                      value="WALLET_LOYALTY"
                      control={<Radio size="small" />}
                      label="Daalchini Point"
                      style={{ fontSize: '14px' }}
                    />
                  </RadioGroup>
                </FormControl>
              )}
            </section>

            <Button
              fullWidth
              variant="contained"
              onClick={orderRefundApi}
              className="submit-button-refund"
              style={{ marginTop: '20px' }}
            >
              Refund
            </Button>
          </div>

          {/* Right Side - Status */}
          {refundDetails?.refundDetailInfoList?.length > 0 ? (
            refundDetails.refundDetailInfoList.map((refund, index) => {
              return (
                <div key={index} className="refund-status-section">
                  <div className="status-card">
                    <Typography variant="h6" className="status-title">
                      Refund Status
                    </Typography>
                    <div className="status-card-inner">
                      <div className="order-id-section">
                        <Typography variant="body1" className="order-id">
                          Order ID : {orderStatus?.orderId}
                        </Typography>
                      </div>

                      <Divider className="section-divider" />

                      <div className="timeline-section">
                        {["REFUND_INITIATED", "REFUND_SUCCESSFUL"].includes(refund.status) ? (
                          <div className="stepper-view">
                            <div className="status-step">
                              <img src={checkIconGreen} alt="Confirmed" />
                              <div>
                                <p className="step-title">Refund Initiated</p>
                                <p className="step-time">
                                  {convertUTCToIST(refund.refundInitiatedTime)}
                                </p>
                              </div>
                            </div>
                            <div className="stepper-line"></div>
                            <div className="status-step">
                              <img
                                src={refund.status === "REFUND_SUCCESSFUL" ? checkIconGreen : emptyCircleIcon}
                                alt="Status"
                              />
                              <div>
                                {refund.status === "REFUND_SUCCESSFUL" ? (
                                  <>
                                    <p className="step-title success">Refund Successful</p>
                                    <p className="step-time success">
                                      {convertUTCToIST(refund.refundCreditTime)}
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p className="step-title">Refund Processing By Bank</p>
                                    <p className="step-time">
                                      Expected settlement time:{" "}
                                      {refund.refundCreditExpectedTime ? (
                                        convertUTCToIST(refund.refundCreditExpectedTime)
                                      ) : (
                                        "Refund initiation time + 60 min"
                                      )}
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="status-view">
                            <div className="status-icon">
                              <img src={(statusConfig[refund.status] || statusConfig.DEFAULT)?.icon} alt="Status" />
                            </div>
                            <p
                              className="status-text"
                              style={{ color: (statusConfig[refund.status] || statusConfig.DEFAULT)?.color }}
                            >
                              {refund.status?.replaceAll("_", " ") || "Unknown Status"}
                            </p>
                            <p className="status-message">
                              <img src={indicator} alt="Indicator" />{" "}
                              {(statusConfig[refund.status] || statusConfig.DEFAULT)?.message}
                            </p>
                          </div>
                        )}
                      </div>

                      <div className="refund-payment-details-section">
                        <div className="payment-item">
                          <Typography variant="body1" className="payment-title">
                            Paid Amount : ₹{refund.paidAmount}
                          </Typography>
                          <Typography variant="body2" className="payment-details">
                            {refund.paymentTime ? convertUTCToIST(refund.paymentTime) : "N/A"}
                          </Typography>
                          <Typography variant="body2" className="payment-details">
                            Transaction ID: {refund.transactionId || "N/A"}
                          </Typography>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <div className="payment-item">
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                <Typography>
                                  Refund Amount : ₹{refund.refundAmount}
                                </Typography>
                              </div>
                              <Typography variant="body1" className="payment-title">
                                <Button
                                  onClick={toggleHistory}
                                  endIcon={showHistory ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                  className="history-toggle-button"
                                />
                              </Typography>
                            </div>

                            {/* ✅ History Section with IST Time */}
                            {showHistory && (
                              <div className="history-content">
                                {loading ? (
                                  <div className="history-loading">
                                    <div className="history-loading-spinner"></div>
                                    <Typography>Loading history...</Typography>
                                  </div>
                                ) : formattedHistoryData?.length > 0 ? (
                                  <div className="history-layout">
                                    {formattedHistoryData.map((item, idx) => (
                                      <div key={idx} className="history-refund-item">
                                        <div className="history-refund-content">
                                          <div className="history-refund-header">
                                            <span className="history-refund-title">Refund Amount</span>
                                            <span className="history-refund-amount">{item.refundAmount}</span>
                                            {item.status === "REFUNDED_BACK" && (
                                              <img src={autorefundIcon} alt="Auto Refund" />
                                            )}
                                          </div>
                                          <div className="history-refund-details">
                                            <div className="history-detail-row">
                                              <span className="history-detail-label">Date:</span>
                                              <span className="history-detail-value">
                                                {item.date || "N/A"}
                                              </span>
                                            </div>
                                            <div className="history-detail-row">
                                              <span className="history-detail-label">Transaction ID:</span>
                                              <span className="history-detail-value">
                                                {item.transactionId || "N/A"}
                                              </span>
                                            </div>
                                            <div className="history-credited-in">
                                              <strong>Credited In:</strong> {item.paymentMethod || "N/A"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <div className="history-empty">
                                    <div className="history-empty-icon">📋</div>
                                    <Typography variant="body2">No refund history found</Typography>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="revoke-button-container">
                            {refund.status === "REFUND_SUCCESSFUL" &&
                              refund.pgName === "RAZORPAY" && (
                                <>
                                  {refund.revokeUpTo > 0 && (
                                    <Button
                                      variant="contained"
                                      onClick={handleOpenRevokeDialog}
                                      className="revoke-button"
                                    >
                                      Revoke & Refund
                                    </Button>
                                  )}

                                  {refund.revokeAmount > 0 && (
                                    <div className="revoked-info" style={{ marginTop: "10px" }}>
                                      <p>
                                        <strong>Revoked Amount:</strong> ₹{refund.revokeAmount.toFixed(2)}
                                      </p>
                                      {refund.revokeTransactionId && (
                                        <p>
                                          <strong>Revoked Transaction ID:</strong> {refund.revokeTransactionId}
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Revoke Dialog */}
                  <Dialog
                    open={openRevokeDialog}
                    onClose={handleCloseRevokeDialog}
                    className="revoke-dialog"
                    fullWidth
                    maxWidth="xs"
                  >
                    <DialogTitle className="dialog-title">
                      <Typography variant="h4" className="refund-amount-display">
                        ₹{refund.revokeUpTo}
                      </Typography>
                    </DialogTitle>
                    <DialogContent>
                      <Typography variant="body1" className="dialog-message">
                        This Amount Will Be Deducted From Daalchini Points And Then Credited Back To Source Account.
                      </Typography>
                    </DialogContent>
                    <DialogActions className="dialog-actions">
                      <Button
                        onClick={handleCloseRevokeDialog}
                        className="dialog-button cancel-button"
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={handleConfirmRevoke}
                        className="dialog-button confirm-button"
                        autoFocus
                      >
                        Confirm
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              );
            })
          ) : (
            <Typography>No refund data found</Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderRefundComponent;